import Image from 'next/image';
import cn from 'classnames';
import styles from '@/styles/pages/index.module.scss';

const RightThings = () => {
  return (
    <>
      <div className={cn('absolute top-60 -right-10', styles.elegirnosRT1)}>
        <Image src="/images/home/elegirnos/rt1.svg" width={22} height={28} alt="" className="w-auto h-auto" />
      </div>
      <div className={cn('absolute bottom-70 -right-40', styles.elegirnosRT2)}>
        <Image src="/images/home/elegirnos/rt2.svg" width={22} height={20} alt="" className="w-auto h-auto" />
      </div>
    </>
  );
};
export default RightThings;
